/** Стабильные свойства точек слоя Автокрафта. Служебные ключи начинаются с `_`. */
export const AUTOCRAFT_GENERATOR_PROPERTY = '_autocraft_generator';
export const AUTOCRAFT_DATA_PROPERTY = '_autocraft_data';
export const AUTOCRAFT_COVER_PROPERTY = 'Макет';
export const AUTOCRAFT_PDF_PROPERTY = 'PDF';
export const AUTOCRAFT_ROTATION_PROPERTY = 'Угол поворота';

export interface AutocraftGenerator {
  hash: string;
  name: string;
}

export type AutocraftFieldType = 'string' | 'text' | 'select' | 'group' | 'link';

export interface AutocraftDataField {
  type: AutocraftFieldType | string;
  label?: string;
  options?: Record<string, string>;
  publicDefaultValue?: string;
  isPublic?: boolean;
  isDeletable?: boolean;
  defaultDrawable?: boolean;
  elementHash?: string;
  elementType?: string;
  parent?: string | null;
}

export interface AutocraftDataModel {
  _order?: string[];
  [fieldKey: string]: AutocraftDataField | string[] | undefined;
}

export interface AutocraftFormItem {
  id?: string;
  type: 'field' | 'heading' | 'separator' | string;
  fieldKey?: string;
  width?: 'full' | 'half' | 'third' | 'quarter' | string;
  text?: string;
}

export interface AutocraftDataForm {
  version?: number;
  formWidth?: 'compact' | 'standard' | 'wide' | string;
  items?: AutocraftFormItem[];
}

export interface AutocraftGeneratorSchema {
  success: boolean;
  generator: AutocraftGenerator;
  dataModel: AutocraftDataModel;
  dataForm?: AutocraftDataForm;
}

export interface AutocraftDiscoverResult {
  generators: AutocraftGenerator[];
  config: { baseUrl: string; projectHash: string };
}

export interface AutocraftGenerationResult {
  pdfUrl: string;
  /** PNG-превью первой страницы макета; `null`, если PDF-сервис не отдал превью. */
  previewUrl: string | null;
  filename: string;
}

export interface AutocraftPreviewResult {
  /** PNG-превью первой страницы макета; `null`, если PDF-сервис не отдал превью. */
  previewUrl: string | null;
}
